import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { store } from "./../index.tsx";

const ProtectedRoutes = (props: any) => {
  const auth = store.getState().AuthReducer?.result?.data;
  return auth ? <Outlet /> : <Navigate to="/LoginPage" />;
};

export default ProtectedRoutes;